import { SETSWEEPSTAKES, SweepstakesActionTypes } from './actionTypes';
import { SweepsDetailsDto } from '../../types';

export function setSweepstakes(dto: SweepsDetailsDto): SweepstakesActionTypes {
  return { type: SETSWEEPSTAKES, ...dto };
}
